import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MarketReportCard = ({ report }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 hover:shadow-lg transition-shadow duration-300">
      <div className="flex items-start gap-4 mb-4">
        <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-primary to-secondary rounded-lg flex items-center justify-center flex-shrink-0">
          <Icon name="FileText" size={24} color="white" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-base md:text-lg font-bold text-foreground mb-2 line-clamp-2">{report?.title}</h3>
          <p className="text-xs md:text-sm text-muted-foreground mb-3 line-clamp-2">{report?.description}</p>
          <div className="flex flex-wrap items-center gap-2">
            <div className="flex items-center gap-1 text-xs text-muted-foreground">
              <Icon name="Calendar" size={14} />
              <span>{report?.date}</span>
            </div>
            <div className="flex items-center gap-1 text-xs text-muted-foreground">
              <Icon name="FileText" size={14} />
              <span>{report?.pages} pages</span>
            </div>
            <span className={`px-2 py-1 rounded text-xs font-medium ${
              report?.type === 'premium' ? 'bg-accent/10 text-accent' : 'bg-muted text-muted-foreground'
            }`}>
              {report?.type === 'premium' ? 'PREMIUM' : 'FREE'}
            </span>
          </div>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Button variant="default" size="sm" fullWidth iconName="Download" iconPosition="left">
          Download Report
        </Button>
        <Button variant="outline" size="sm" iconName="Eye" className="flex-shrink-0" />
      </div>
    </div>
  );
};

export default MarketReportCard;